// 英文
const en = {
    name:'name',
    info:{
        age:'male'
    }
}

export default en;


// WEBPACK FOOTER //
// ./src/i18n/config/en.js